import { useState } from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import { GlobalSearchDesktop } from "./global-search/GlobalSearchDesktop";
import { GlobalSearchMobile } from "./global-search/GlobalSearchMobile";
import { GlobalSearchTriggerMobile } from "./global-search/GlobalSearchTriggerMobile";

// ---------------------------------------------------------------------------
// Unified export: auto-selects desktop vs mobile
// ---------------------------------------------------------------------------

export default function GlobalSearch() {
  const isMobile = useIsMobile();
  const [mobileOpen, setMobileOpen] = useState(false);

  if (isMobile) {
    return (
      <>
        <GlobalSearchTriggerMobile onOpen={() => setMobileOpen(true)} />
        <GlobalSearchMobile open={mobileOpen} onClose={() => setMobileOpen(false)} />
      </>
    );
  }

  return <GlobalSearchDesktop />;
}

// Re-export sub-components for direct imports
export { GlobalSearchDesktop } from "./global-search/GlobalSearchDesktop";
export { GlobalSearchMobile } from "./global-search/GlobalSearchMobile";
export { GlobalSearchTriggerMobile } from "./global-search/GlobalSearchTriggerMobile";
